import { render } from "./LineColumnSeguridadPublica.vue?vue&type=template&id=292f0057&scoped=true"
import script from "./LineColumnSeguridadPublica.vue?vue&type=script&lang=js"
export * from "./LineColumnSeguridadPublica.vue?vue&type=script&lang=js"

import "./LineColumnSeguridadPublica.vue?vue&type=style&index=0&id=292f0057&scoped=true&lang=css"

import exportComponent from "/Users/luismanuel/Documents/www/tuxtlacomovamos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-292f0057"]])

export default __exports__